export const SET_PAYMENT = 'set_payment';
export const PAYMENT_METHOD = 'payment_method';
export const PAYER_FORM = 'payer_form';
export const CLIENT_FORM = 'client_form';
export const REVIEW = 'review';
export const CARD_FORM = 'card_form';
